<div class="p-3">
    <ng-content></ng-content>
</div>